<template>
  <div class="video-list">
    <div
      v-for="item in videoList"
      v-bind:video="item"
      v-bind:key="item.id"
      class="video-item"
      :class="[
        { AppExpertSide: $route.name == 'App' },
        { AppChildSide: $route.name == 'AppChildSide' },
        { expertHide: expertHide },
        { childHide: childHide }
      ]"
    >
      <video
        :class="[
          { local: item.type == 'local' },
          { remote: item.type != 'local' }
        ]"
        autoplay
        playsinline
        ref="videos"
        :height="cameraHeight"
        :muted="item.muted"
        :id="item.id"
      ></video>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import RTCMultiConnection from "rtcmulticonnection";
require("adapterjs");
export default {
  name: "vue-webrtc",
  components: {
    RTCMultiConnection
  },
  data() {
    return {
      rtcmConnection: null,
      localVideo: null,
      videoList: [],
      canvas: null,
      expertHide: false,
      childHide: false
    };
  },
  props: {
    roomId: {
      type: String,
      default: "public-room"
    },
    socketURL: {
      type: String,
      // default: 'https://rtcmulticonnection.herokuapp.com:443/'
      default: "http://188.166.91.211:9001/"
    },
    cameraHeight: {
      type: [Number, String],
      default: 160
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    screenshotFormat: {
      type: String,
      default: "image/jpeg"
    },
    enableAudio: {
      type: Boolean,
      default: true
    },
    enableVideo: {
      type: Boolean,
      default: true
    },
    enableLogs: {
      type: Boolean,
      default: true
    },
    stunServer: {
      type: String,
      default: null
    },
    turnServer: {
      type: String,
      default: null
    }
  },
  sockets: {
    hideCamera: function(data) {
      if (data.who == "expert") {
        this.expertHide = !this.expertHide;
      } else {
        this.childHide = !this.childHide;
      }
    },
    childDisconnected: function() {
      this.expertHide = false;
      this.childHide = false;
    }
  },
  watch: {},
  mounted() {
    var that = this;

    this.rtcmConnection = new RTCMultiConnection();
    this.rtcmConnection.socketURL = this.socketURL;
    this.rtcmConnection.autoCreateMediaElement = false;
    this.rtcmConnection.enableLogs = this.enableLogs;
    this.rtcmConnection.session = {
      audio: this.enableAudio,
      video: this.enableVideo
    };
    this.rtcmConnection.sdpConstraints.mandatory = {
      OfferToReceiveAudio: this.enableAudio,
      OfferToReceiveVideo: this.enableVideo
    };

    if (this.stunServer !== null || this.turnServer !== null) {
      this.rtcmConnection.iceServers = []; // clear all defaults
    }
    if (this.stunServer !== null) {
      this.rtcmConnection.iceServers.push({
        urls: this.stunServer
      });
    }
    this.rtcmConnection.iceServers = [];

    //     this.rtcmConnection.iceServers.push({
    //     url: 'stun:stun.anyfirewall.com:3478'
    // });

    this.rtcmConnection.iceServers.push({
      urls: ["stun:eu-turn7.xirsys.com"]
    });
    this.rtcmConnection.iceServers.push({
      username:
        "P3TacJegTBCAr6EkkhnxsNciT_95-dBIskjsUb97xGrMPszSaSWWHIy23f1hvwc7AAAAAGBobxBlcnR1b3pkZW5saQ==",
      credential: "6aa59854-9481-11eb-b2e4-0242ac140004",
      urls: [
        "turn:eu-turn7.xirsys.com:80?transport=udp",
        "turn:eu-turn7.xirsys.com:3478?transport=udp",
        "turn:eu-turn7.xirsys.com:80?transport=tcp",
        "turn:eu-turn7.xirsys.com:3478?transport=tcp",
        "turns:eu-turn7.xirsys.com:443?transport=tcp",
        "turns:eu-turn7.xirsys.com:5349?transport=tcp"
      ]
    });

    // //  this.turnServer = "turn:turn02.hubl.in?transport=tcp";

    //     if (this.turnServer !== null) {
    //       var parse = this.turnServer.split("%");
    //       var username = parse[0].split("@")[0];
    //       var password = parse[0].split("@")[1];
    //       var turn = parse[1];
    //       this.rtcmConnection.iceServers.push({
    //         urls: turn,
    //         credential: password,
    //         username: username
    //       });
    //     }

    this.rtcmConnection.onstream = function(stream) {
      let found = that.videoList.find(video => {
        return video.id === stream.streamid;
      });
      if (found === undefined) {
        let video = {
          id: stream.streamid,
          muted: stream.type === "local",
          type: stream.type
        };

        that.videoList.push(video);

        // if (stream.type === "local") {
        //   that.localVideo = video;
        // }
      }

      setTimeout(function() {
        for (var i = 0, len = that.$refs.videos.length; i < len; i++) {
          if (that.$refs.videos[i].id === stream.streamid) {
            that.$refs.videos[i].srcObject = stream.stream;
            break;
          }
        }
        if (that.videoList.length > 2) {
          that.videoList = that.videoList.filter(
            video => video.type != stream.type
          );
          let video = {
            id: stream.streamid,
            muted: stream.type === "local",
            type: stream.type
          };

          that.videoList.push(video);
        }
      }, 1000);

      that.$emit("joined-room", { id: stream.streamid, type: stream.type });
    };
    this.rtcmConnection.onstreamended = function(stream) {
      var newList = [];
      that.videoList.forEach(function(item) {
        if (item.id !== stream.streamid) {
          newList.push(item);
        }
      });
      that.videoList = newList;
      that.$emit("left-room", stream.streamid);
    };
  },
  methods: {
    join() {
      var that = this;
      this.rtcmConnection.openOrJoin(this.roomId, function(
        isRoomExist,
        roomid
      ) {
        if (isRoomExist === false && that.rtcmConnection.isInitiator === true) {
          that.$emit("opened-room", roomid);
        }
      });
    },
    leave() {
      this.rtcmConnection.attachStreams.forEach(function(localStream) {
        localStream.stop();
      });
      this.videoList = [];
    },
    capture() {
      return this.getCanvas().toDataURL(this.screenshotFormat);
    },
    getCanvas() {
      let video = this.getCurrentVideo();
      if (video !== null && !this.ctx) {
        let canvas = document.createElement("canvas");
        canvas.height = video.clientHeight;
        canvas.width = video.clientWidth;
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
      }
      const { ctx, canvas } = this;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas;
    },
    getCurrentVideo() {
      if (this.localVideo === null) {
        return null;
      }
      for (var i = 0, len = this.$refs.videos.length; i < len; i++) {
        if (this.$refs.videos[i].id === this.localVideo.id)
          return this.$refs.videos[i];
      }
      return null;
    }
  }
};
</script>
